import Loading from 'shared/components/loading';
import styles from 'shared/registration/stylesheets/achievement-cards.module.scss';
import AchievementCard from 'src/components/form/onboarding/AchievementSelection/AchievementCard';
import React, {useContext, useEffect, useState} from 'react';
import {AchievementOption} from 'src/types/education';
import {OnboardingContext} from 'src/components/Onboarding/context';
import {omit} from 'lodash';
import UserService from 'src/services/UserService';

export default function AchievementCards(): React.ReactElement {
  const [achievementOptions, setAchievementOptions] = useState<AchievementOption[]>([]);
  const [idMap, setIdMap] = useState<Record<string, string>>({});
  const [selectedAchievements, setSelectedAchievements] = useState<string[]>([]);
  const onboardingContext = useContext(OnboardingContext);
  const mustSelect = selectedAchievements.length === 0;

  useEffect(() => {
    if (mustSelect) {
      onboardingContext.updatePrimaryButton({
        controlled: true,
        text: 'Select 1',
        disabled: true,
      });
    } else if (onboardingContext.primaryButton.controlled) {
      onboardingContext.resetPrimaryButton();
    }
  }, [mustSelect]);

  useEffect(() => {
    UserService.getAchievementItems().then((achievements) => setAchievementOptions(achievements));
  }, []);

  useEffect(() => {
    UserService.getPotentialPortfolioItems().then((items) => {
      const map = items.reduce((acc, current) => {
        acc[current.name] = current._id;
        return acc;
      }, {});

      setIdMap(map);
      setSelectedAchievements(items.map(({name}) => name));
    });
  }, []);

  async function handleCardClick(name: string, isSelected: boolean): Promise<void> {
    if (isSelected && !selectedAchievements.includes(name)) {
      const achievement = achievementOptions.find((x) => x.name === name) as AchievementOption;
      setSelectedAchievements([...selectedAchievements, name]);

      const updatedAchievement = await UserService.savePotentialAchievement(achievement);
      setIdMap({...idMap, [name]: updatedAchievement._id});
    } else {
      setSelectedAchievements(selectedAchievements.filter((achievements) => achievements !== name));
      setIdMap(omit(idMap, name));
      await UserService.removePotentialAchievement(idMap[name]);
    }
  }

  return (
    <div className="achievement-step">
      {achievementOptions.length === 0 ? (
        <Loading />
      ) : (
        <div className={styles.container}>
          {achievementOptions.map((option) => (
            <AchievementCard
              key={option.name}
              onClick={handleCardClick}
              isSelected={selectedAchievements.includes(option.name)}
              trackPrefix="registration-achievement"
              data={option}
            />
          ))}
        </div>
      )}
    </div>
  );
}
